export enum ECartesianAxis {
  X = 0,
  Y = 1,
  Z = 2,
}

export enum ECylindricalAxis {
  T = 0,
  E = 1,
  Z = 2,
}

export enum ECoordinateSystem {
  Cartesian,
  ExtendedCylindrical,
}
